import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Cleaning from "@/pages/Cleaning";
import ServicePage from "@/pages/ServicePage";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/cleaning" element={<Cleaning />} />
          <Route path="/services/:slug" element={<ServicePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#131c17",
            border: "1px solid rgba(138,178,115,0.25)",
            color: "#f5efe4",
          },
        }}
      />
    </div>
  );
}

export default App;
